import React, { useState } from "react";
import SignatureInput from "./SignatureInput"; // ✅ include component

const MarkUnsuccessfulForm = ({ servee, location, onSubmit, onCancel, isLoading }) => {
    const [notes, setNotes] = useState('');
    const [proofFile, setProofFile] = useState(null);
    const [signatureFile, setSignatureFile] = useState(null); // Stored after upload or pad confirm
    const [notaryMode, setNotaryMode] = useState(true);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!notes.trim()) {
            alert("Please enter the notes/reasons for the unsuccessful service.");
            return;
        }

        const finalPayload = {
            servee_id: servee.id,
            notes,
            latitude: location.lat,
            longitude: location.lng,
            notary_mode: notaryMode,
        };

        onSubmit(finalPayload, proofFile, signatureFile);
    };

    return (
        <div className="p-4 border border-red-300 rounded-md bg-red-50">
            <h4 className="font-bold text-red-700">
                Finalize Unsuccessful Service for {servee.full_name}
            </h4>

            <form onSubmit={handleSubmit} className="mt-2 space-y-4">
                
                {/* NOTES FIELD */}
                <label className="block">
                    <span className="text-sm font-medium text-gray-700">
                        Final Notes / Reason for Failure (Mandatory):
                    </span>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="3"
                        placeholder="Servee could not be located, or attempts failed due to..."
                        className="w-full border p-2 text-sm rounded-md"
                        required
                    />
                </label>

                {/* OPTIONAL PROOF */}
                <label className="block">
                    <span className="text-sm font-medium text-gray-700">
                        Evidence File (Optional Photo / Document):
                    </span>
                    <input
                        type="file"
                        onChange={(e) => setProofFile(e.target.files[0])}
                        className="text-sm border p-1 w-full mt-1"
                    />
                </label>

                {/* ✅ SIGNATURE (UPLOAD OR PAD) */}
                <SignatureInput
                    value={signatureFile}
                    onChange={setSignatureFile}
                    label="Server Signature (Optional)"
                />

             <label className="flex items-center gap-1 mb-4">
                    
                    <input
                        type="checkbox"
                        checked={notaryMode === true}
                        onChange={() => setNotaryMode(notaryMode === true ? false : true)}
                    />
                    <span className="text-sm font-medium text-gray-700">Add Notary Signature Block To Affidavit</span>
            
            </label>



                {/* ACTION BUTTONS */}
                <div className="flex space-x-2">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                        {isLoading ? 'Finalizing...' : 'Submit Non-Service Affidavit'}
                    </button>

                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-4 py-2 bg-gray-400 text-white rounded"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default MarkUnsuccessfulForm;
